import {Component, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JsonLdObject } from '@think-it-labs/edc-connector-client';
import { PolicyRuleModalComponent } from '../policy-rule-modal/policy-rule-modal.component';
import { PolicyRule } from '../../models/policy-rule';
import { OBLIGATION_RULE, PERMISSION_RULE, PROHIBITION_RULE } from 'src/modules/app/policy-rule-types';

@Component({
  selector: 'policy-rules',
  templateUrl: './policy-rule-viewer.component.html',
  styleUrls: ['./policy-rule-viewer.component.scss']
})
export class PolicyRuleViewerComponent implements OnInit {

  @Input() title: string = "Policy rules";
  @Input() permissionRules: any[] | undefined = [];
  @Input() prohibitionRules: any[] | undefined = [];
  @Input() obligationRules: any[] | undefined = [];

  rules: PolicyRule[] = [];


  constructor(public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.rules = this.getTransformedRules();
    console.log(this.rules);
  }

  private getTransformedRules(): PolicyRule[] {
    const permissionRules = this.normalizeRules(this.permissionRules);
    const prohibitionRules = this.normalizeRules(this.prohibitionRules);
    const obligationRules = this.normalizeRules(this.obligationRules);

    return [
      ...permissionRules.map((rule: any) =>
        this.getTransformedRule(rule, PERMISSION_RULE.id)
      ),
      ...prohibitionRules.map((rule: any) =>
        this.getTransformedRule(rule, PROHIBITION_RULE.id)
      ),
      ...obligationRules.map((rule: any) =>
        this.getTransformedRule(rule, OBLIGATION_RULE.id)
      ),
    ];
  }

  private normalizeRules(rules: any): any[] {
    return this.asArray(rules).map((rule: any) => this.normalizeRule(rule));
  }

  private asArray<T>(value: T | T[] | null | undefined): T[] {
    if (value == null) {
      return [];
    }

    return Array.isArray(value) ? value : [value];
  }

  private normalizeRule(rawRule: any): any {
    if (!rawRule) {
      return rawRule;
    }

    const normalized: any = {};

    for (const [key, value] of Object.entries(rawRule)) {
      if (key === 'odrl:action' || key === 'action') {
        normalized.action = this.normalizeOdrlValue(value);
        continue;
      }

      if (key.startsWith('odrl:')) {
        normalized[this.stripPrefix(key)] = this.normalizeOdrlValue(value);
        continue;
      }

      normalized[key] = this.normalizeOdrlValue(value);
    }

    return normalized;
  }

  private normalizeOdrlValue(value: any): any {
    if (value == null) {
      return value;
    }

    if (typeof value === 'string') {
      return this.stripPrefix(value);
    }

    if (Array.isArray(value)) {
      return value.map((x) => this.normalizeOdrlValue(x));
    }

    if (typeof value === 'object' && '@id' in value) {
      return this.stripPrefix(value['@id']);
    }

    return value;
  }

  private stripPrefix(value: string): string {
    return value.includes(':') ? value.split(':').pop()! : value;
  }

  private getTransformedRule(rawRule: JsonLdObject, type: string): PolicyRule {
    const content = rawRule;
    return {
      type: type,
      content: content,
    }
  }

  getTypeColor(type: string) {
    return "warn";
  }

  openDialog(content: JsonLdObject): void {
    const dialogRef = this.dialog.open(PolicyRuleModalComponent, {
      width: 'fit-content',
      data: { content: content }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}
